const blogs = [
    {
        id: 1,
        title: "Amsterdam: Jet lag, Tragic history, and Canals",
        description: "I still believe, in spite of everything, that people are truly good at heart.” Anne Frank Considering what Anne Frank and her family, and hundreds of thousands of other Dutch Jews, went through during the Nazi occupation of the Netherlands in World War II.",
        date: "October 11,2021",
        type: "History",
        img: "https://i.ibb.co/HzdpdzR/1.jpg"
    },
    {
        id: 2,
        title: "Best Neighborhoods in Lisbon: Where to Stay During Your Visit",
        description: "2021 has come, maybe not with a bang as a lot of us may have hoped, but the world goes on and as such I have decided to extend this most beautiful travel blogs list even further with 6 new travel blogs to check out, bringing it to 20, a perfect number for the 2021 year.",
        date: "October 21,2021",
        type: "City Tour",
        img: "https://i.ibb.co/kKF9XFg/2.jpg"
    },
    {
        id: 3,
        title: "The Best Walking Tours in New Orleans",
        description: "As some of you may know, I have been in the design industry for the past 10 years working as a freelance designer in various companies while also running this blog. In fact, the majority of my income is mostly from my design freelance work over at The Pete Design.",
        date: "October 15,2021",
        type: "Walking Tour",
        img: "https://i.ibb.co/sjFXsSr/3.jpg"
    },
    {
        id: 4,
        title: "Croatia is Underappreciated",
        description: "I value well-designed products and today, I want to dive down into the design of travel blogs and featured the best design travel blogs out there that take storytelling to the next level and hopefully inspire you to create an awesome travel blog of your own this article is as close as you can get to being near these beautiful stunning whales.",
        date: "October 14,2021",
        type: "City Tour",
        img: "https://i.ibb.co/ck75nfq/4.jpg"
    },
    {
        id: 5,
        title: "Perspective – Traveling with a Mental Illness",
        description: "This is all good for beginners but when these blogs grow, most bloggers forgot about design and instead doubled down on SEO and marketing, sometimes sacrificing user experience for profit. Their identities are diluted over time and hence why most of the travel blogs you see nowadays feel similar to one another.",
        date: "October 25,2021",
        type: "Travel Health",
        img: "https://i.ibb.co/PTzwfQP/5.jpg"
    },
    {
        id: 6,
        title: "How to Plan a Thematic Travel Adventure",
        description: "The layout of the travel blog merely serves as a white canvas to emphasize the atmospheric and immersive photography that Anywhere We Roam is a master at. Their photography and writings are top-notch and has the ability to transport you to the location in question.",
        date: "October 18,2021",
        type: "Adventure",
        img: "https://i.ibb.co/tcdQGKD/6.jpg"
    }
]
export default blogs;